import styled, { css } from "styled-components";
import { media, theme } from "../../theme/theme";
import { LEFT_SIDE_MENU_WIDTH } from "../../layout/SideBarLayout/SidebarLayout.styles";

const BarWidth = css`
    width: 100%;
    left: 0;

    ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
        width: calc(100vw - ${LEFT_SIDE_MENU_WIDTH}px);
        left: ${LEFT_SIDE_MENU_WIDTH}px;
    }
`;

export const V3StickyTopBarWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    padding: 16px 20px;
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.05);
    z-index: 2;
    display: flex;
    background: #ffffff;
    height: 70px;

    ${BarWidth}
`;

export const V3StickyBottomBarWrapper = styled.div`
    position: fixed;
    bottom: 0;
    padding: 16px 20px;
    background: #ffffff;
    box-shadow: 0px 0px 30px -16px rgba(0, 0, 0, 0.5);
    z-index: 2;
    display: flex;

    ${BarWidth}
`;

export const V3StickyTopBarContent = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 auto;
    width: 100%;

    > div {
        margin-right: 15px;
    }
`;

export const V3StickyBottomBarContent = styled.div<{ $maxWidth?: number, $alignBottom : boolean}>`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    max-width: ${({ $maxWidth }) => `${$maxWidth}px`};
    margin: 0 auto;
    width: 100%;
    flex-direction: column;

    ${media.custom(1120)} {
       flex-direction: row;
       align-items: ${({ $alignBottom }) => $alignBottom ? "flex-end" : "center"};
    }

    > div {
        &:first-child {
            align-self: flex-start;
            margin-bottom: 24px;

            ${media.custom(1120)} {
                margin-right: 15px;
                margin-bottom: 0;
            }
        }
    }
`;

export const V3StickyBottomBarWrapperBtnPanel = styled.div`
    display: flex;
    align-items: center;

    > div {
        &:first-child {
            margin-right: 14px;
        }
    }
`;